export default {
    diagonal: 'diagonal',
    round:    'round',
};